'use strict';
import * as $j_app$002eapi$002e$002dPharmacy$002dApp$002dUpdate$0024$002dNew$002dMessage$002dIn$002dChats from "./app.api.-Pharmacy-App-Update$-New-Message-In-Chats.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_PharmacyAppUpdate$NewMessageInChats$() {
}
export { $c_Lapp_api_PharmacyAppUpdate$NewMessageInChats$ as $c_Lapp_api_PharmacyAppUpdate$NewMessageInChats$ };
$c_Lapp_api_PharmacyAppUpdate$NewMessageInChats$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_PharmacyAppUpdate$NewMessageInChats$.prototype.constructor = $c_Lapp_api_PharmacyAppUpdate$NewMessageInChats$;
/** @constructor */
function $h_Lapp_api_PharmacyAppUpdate$NewMessageInChats$() {
}
export { $h_Lapp_api_PharmacyAppUpdate$NewMessageInChats$ as $h_Lapp_api_PharmacyAppUpdate$NewMessageInChats$ };
$h_Lapp_api_PharmacyAppUpdate$NewMessageInChats$.prototype = $c_Lapp_api_PharmacyAppUpdate$NewMessageInChats$.prototype;
$c_Lapp_api_PharmacyAppUpdate$NewMessageInChats$.prototype.toString__T = (function() {
  return "NewMessageInChats";
});
$c_Lapp_api_PharmacyAppUpdate$NewMessageInChats$.prototype.fromProduct__s_Product__Lapp_api_PharmacyAppUpdate$NewMessageInChats = (function(x$0) {
  var ids$5 = x$0.productElement__I__O(0);
  return new $j_app$002eapi$002e$002dPharmacy$002dApp$002dUpdate$0024$002dNew$002dMessage$002dIn$002dChats.$c_Lapp_api_PharmacyAppUpdate$NewMessageInChats(ids$5);
});
$c_Lapp_api_PharmacyAppUpdate$NewMessageInChats$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lapp_api_PharmacyAppUpdate$NewMessageInChats(p);
});
var $d_Lapp_api_PharmacyAppUpdate$NewMessageInChats$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_PharmacyAppUpdate$NewMessageInChats$, "app.api.PharmacyAppUpdate$NewMessageInChats$", ({
  Lapp_api_PharmacyAppUpdate$NewMessageInChats$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lapp_api_PharmacyAppUpdate$NewMessageInChats$ as $d_Lapp_api_PharmacyAppUpdate$NewMessageInChats$ };
var $n_Lapp_api_PharmacyAppUpdate$NewMessageInChats$;
function $m_Lapp_api_PharmacyAppUpdate$NewMessageInChats$() {
  if ((!$n_Lapp_api_PharmacyAppUpdate$NewMessageInChats$)) {
    $n_Lapp_api_PharmacyAppUpdate$NewMessageInChats$ = new $c_Lapp_api_PharmacyAppUpdate$NewMessageInChats$();
  }
  return $n_Lapp_api_PharmacyAppUpdate$NewMessageInChats$;
}
export { $m_Lapp_api_PharmacyAppUpdate$NewMessageInChats$ as $m_Lapp_api_PharmacyAppUpdate$NewMessageInChats$ };
//# sourceMappingURL=app.api.-Pharmacy-App-Update$-New-Message-In-Chats$.js.map
